// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/lazy';
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import Viser from 'viser-vue';
import axios from 'axios';
import '@/mock';
import store from './store';
import PouchDB from 'pouchdb';
// import VueResource from 'vue-resource';
import echarts from 'echarts';
import VueCookies from 'vue-cookies';
import '@/utils/rsa'
Vue.use(echarts);
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$RSAUtils = window.RSAUtils;
axios.defaults.withCredentials = true;
Vue.config.productionTip = false;
Vue.use(Viser);
Vue.use(Antd);
Vue.use(VueCookies);
// Vue.use(VueResource);
/* eslint-disable no-new */
router.onError((err) => {
  console.log('err', err);
});
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    /* 没用到PouchDB库 */
    // var db = new PouchDB('admindb');
    // db.get('currUser').then(doc => {
    //   this.$store.commit('account/setuser', doc.user)
    // });
  }
});



// WEBPACK FOOTER //
// ./src/main.js